import { DefaultTheme } from "styled-components";

// See styled.d.ts for where we extend the styled components DefaultTheme

const baseTheme = {
  font: {
    fontFamily: "-apple-system, Roboto, sans-serif",
  },
  // Screen sized used for media query break points and widths / max-widths
  screenSize: {
    xs: 400,
    s: 500,
    m: 800,
    l: 1100,
    xl: 1300,
    xxl: 1500,
  },
  borderRadius: {
    circle: "50%",
    switch: "0.6rem",
    image: "10px",
    button: "5px",
    card: "5px",
  },
};

export const lightTheme: DefaultTheme = {
  LightOrDark: "light",
  colours: {
    // black
    foreground: "#171717",
    // white
    background: "#ffffff",
    lightGrey: "#b8b8b8",
    midGrey: "#8a8a8a",
    disabled: "#cfcfcf",
    darkBlue: "#1D3A86",
    midBlue: "#0070b8",
    orange: "#FF942A",
    danger: "#ff2929",
  },
  ...baseTheme,
};

export const darkTheme: DefaultTheme = {
  LightOrDark: "dark",
  colours: {
    // white
    foreground: "#ffffff",
    // black
    background: "#171717",
    lightGrey: "#b8b8b8",
    midGrey: "#8a8a8a",
    disabled: "#cfcfcf",
    darkBlue: "#1D3A86",
    midBlue: "#0070b8",
    orange: "#FF942A",
    danger: "#ff2929",
  },
  ...baseTheme,
};
